import { render, staticRenderFns } from "./EvaluacionDesempenioForm.vue?vue&type=template&id=a24cf660"
import script from "./EvaluacionDesempenioForm.vue?vue&type=script&lang=js"
export * from "./EvaluacionDesempenioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports